<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="厂商名称：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="厂家介绍：" prop="description">
                <el-input type="textarea" :rows="4" v-model="model.description"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'producerEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                name: '',
                description: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/producer/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                name: [
                    {required: true, message: '厂商名称不能为空', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/producer/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>